export default "__VITE_ASSET__BocQ$Kar__"